//window.isLogin       = typeof window.isLogin === "boolean" ? window.isLogin : false;
//window.userLoggedIn  = typeof window.userLoggedIn === "boolean" ? window.userLoggedIn : window.isLogin;
//window.customerData  = window.customerData || { tags: [] };

const qs  = (s, r = document) => r.querySelector(s);
const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
const modal = qs("#myModal");

if (window.dayjs && window.dayjs_plugin_utc && window.dayjs_plugin_timezone && window.dayjs_plugin_isSameOrBefore) {
  dayjs.extend(window.dayjs_plugin_utc);
  dayjs.extend(window.dayjs_plugin_timezone);
  dayjs.extend(window.dayjs_plugin_isSameOrBefore);
}

/* ---------- Loader overlay ---------- */
function showMiniCartLoader() {
  qs('#loaderContainer')?.classList.add('active');
}
function hideMiniCartLoader() {
  qs('#loaderContainer')?.classList.remove('active');
}

/* ---------- Simple validators ---------- */
const vEmail = v => /\S+@\S+\.\S+/.test(String(v || ""));
const vPhoneLoose = v => String(v || "").replace(/\D/g, "").length >= 8;
const vAddr = v => String(v || "").trim().length >= 1;

const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const isValidEmailNew = (v) => emailRe.test(String(v || "").trim());

/* ---------- Step 1: Phone ONLY ---------- */
//const email1      = qs("#email1"); // hidden but kept for compatibility
const phone1      = qs("#phone1");
const startBtn    = qs("#continueStart");
const startHint   = qs("#startHint");
//const email2      = qs("#email2");
//const phone2      = qs("#phone2");

const address1   = qs("#address_11");
const suburb1    = qs("#suburb_11");
const state1El   = qs("#state_11");
const postcode1  = qs("#postcode_11");

const address2   = qs("#address_12");
const suburb2    = qs("#suburb_12");
const state2El   = qs("#state_12");
const postcode2  = qs("#postcode_12");

const subscribeCard = qs('[data-plan="subscribe"]');
const onetimeCard   = qs('[data-plan="onetime"]');
const step1_divider = qs("#step1_divider");
const phone1Text    = qs("#phone1Text");
const login1Text    = qs("#login1Text");
const register1Text    = qs("#register1Text");
const phone1SendAgain = qs("#phone1SendAgain");
const continueBtn         = qs("#continueStart");
const back_1_1         = qs("#back_1_1");
const preWrap = qs("#pre_selected_data_wrap");


function validateAndNormalizeAuPhone(raw) {
  if (!raw) return { ok: false };

  let s = String(raw).replace(/[^\d+]/g, "");
  let digits = s.replace(/\D/g, "");

  // User must NOT type +61 or 61 manually (we add +61 ourselves)
  if (s.startsWith("+61") || digits.startsWith("61")) {
    return { ok: false };
  }

  if (digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  if (digits.length !== 9) return { ok: false };
  if (!/^[23478]\d{8}$/.test(digits)) return { ok: false };

  return { ok: true, e164: `+61${digits}` };
}

function startBtnShowActive(booLean = false){
  if(booLean){
    if((state.phone && state.address && state.suburb && state.state && state.postcode && (state.phone != '') && (state.address != '') && (state.suburb != '') && (state.state != '') && (state.postcode != ''))){  
      startBtn?.classList.remove("hidden");
      startBtn.disabled = false;
    }else{
      startBtn?.classList.remove("hidden");
      startBtn.disabled = true;
    } 
  }else{
    startBtn?.classList.remove("hidden");
    startBtn.disabled = true;
  }
}

/* ---------- Field error helpers ---------- */
function setFieldState(input, ok, msg = "") {
  if (!input) return;
  const val = (input.value || "").trim();

  // Blank => no error message or invalid styling
  if (val === "") {
    input.classList.remove("is-invalid");
    const maybe = input.nextElementSibling;
    if (maybe && maybe.classList.contains("error-text")) {
      maybe.textContent = "";
    }
    const parent = input.parentElement;
    if (input.id === "phone1" || input.id === "phone2") {
      parent?.classList.remove("has-error");
    }
    return;
  }

  input.classList.toggle("is-invalid", !ok);

  let hint = input.nextElementSibling;
  if (!hint || !hint.classList.contains("error-text")) {
    hint = document.createElement("small");
    hint.className = "error-text";
    input.insertAdjacentElement("afterend", hint);
  }

  const parent = input.parentElement;
  if (input.id === "phone1" || input.id === "phone2") {
    if (!ok) parent?.classList.add("has-error");
    else parent?.classList.remove("has-error");
  }

  hint.style.color = ok ? "inherit" : "#ef4444";
  hint.textContent = ok ? "" : msg;
}

/* ---------- Delivery parsing helpers ---------- */
const parseDeliveryDateLabel = (label) => {
  const m = /\(([^)]+)\)$/.exec(String(label || ""));
  return m ? m[1] : String(label || "");
};
const parseTimeSlot = (slot) => {
  const parts = String(slot || "").split(/–|-/).map(s => s.trim());
  const pad = s => {
    const [h, m = "00"] = s.split(":");
    return `${String(h).padStart(2, "0")}:${m}`;
  };
  return parts.length === 2 ? [pad(parts[0]), pad(parts[1])] : ["", ""];
};
const extractPostcodeAU = (address) => {
  const m = String(address || "").match(/\b(\d{4})\b(?!.*\b\d{4}\b)/);
  return m ? m[1] : "";
};

/* ---------- Address state helpers ---------- */
function setAttributeValuesMiniCart(metaData) {
  const { address_line_combined, locality_name, state_territory, postcode } = metaData || {};

  const mappings = [
    ["address_11", address_line_combined],
    ["suburb_11", locality_name],
    ["state_11", state_territory],
    ["postcode_11", postcode],
    ["address_12", address_line_combined],
    ["suburb_12", locality_name],
    ["state_12", state_territory],
    ["postcode_12", postcode]
  ];

  mappings.forEach(([id, value]) => {
    const el = document.getElementById(id);
    if (el && value != null) el.value = value;
  });

  try {
    if (locality_name) {
      state.address = address_line_combined || state.address;
      state.suburb = locality_name;
      state.state = state_territory || state.state;
      state.postcode = postcode || state.postcode;
    }
    localStorage.setItem("widgetAddress", JSON.stringify({
      address_line_combined: state.address,
      locality_name: state.suburb,
      state_territory: state.state,
      postcode: state.postcode
    }));

    if((state.phone && state.address && state.suburb && state.state && state.postcode && (state.phone != '') && (state.address != '') && (state.suburb != '') && (state.state != '') && (state.postcode != ''))){  

      startBtnShowActive(true);
      startBtn.click();

    }else{

      startBtnShowActive(false);
      address_group?.classList.add("hidden");
      step1_divider?.classList.add("hidden");
      qs("#back_1_1")?.classList.remove("hidden");

    }

    persist();
  } catch (err) {
    console.error("Error storing widgetAddress:", err);
  }
}

/* ---------- AddressFinder init ---------- */
(function () {
  function initAddressFinder() {
    const locaDelInit = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    const expectedDateInit = locaDelInit.deliveryDate && currentDate
      ? dayjs(locaDelInit.deliveryDate)
      : currentDate;

    const dataTag = document.getElementById("customer-default-address");
    if (dataTag) {
      try {
        const d = JSON.parse(dataTag.textContent || "{}");


        state.address  = state.address || d.address;
        state.suburb   = state.suburb  || d.suburb;
        state.state    = state.state  || d.state;
        state.postcode = state.postcode  || d.postcode;

        if (a11 && state.address) a11.value = state.address;
        if (a12 && state.address) a12.value = state.address;

        const a11 = document.getElementById("address_11");
        if (state.suburb) document.getElementById("suburb_11")?.setAttribute("value", state.suburb);
        if (state.state)  document.getElementById("state_11")?.setAttribute("value", state.state);
        if (state.postcode) document.getElementById("postcode_11")?.setAttribute("value", state.postcode);

        const a12 = document.getElementById("address_12");
        if (state.suburb) document.getElementById("suburb_12")?.setAttribute("value", state.suburb);
        if (state.state)  document.getElementById("state_12")?.setAttribute("value", state.state);
        if (state.postcode) document.getElementById("postcode_12")?.setAttribute("value", state.postcode);

        

      } catch (e) {
        console.warn("Failed to parse customer-default-address JSON:", e);
      }
    }

    if (!window.AddressFinder) return;

    const widget_1 = new AddressFinder.Widget(
      document.getElementById("address_11"),
      "XDGLJVBHMQAKF68W4CT7",
      "AU",
      { address_params: { gnaf: "1" } }
    );

    const widget_2 = new AddressFinder.Widget(
      document.getElementById("address_12"),
      "XDGLJVBHMQAKF68W4CT7",
      "AU",
      { address_params: { gnaf: "1" } }
    );

    function onResult(fullAddress, metaData) {
      setAttributeValuesMiniCart(metaData);
      if (typeof listSuburbsBasedOnPostCode === "function") {
        listSuburbsBasedOnPostCode(metaData.postcode, metaData.locality_name, expectedDateInit);
      }
    }

    widget_1.on("result:select", onResult);
    widget_2.on("result:select", onResult);

  }

  function downloadAddressFinder() {
    const script = document.createElement("script");
    script.src = "https://api.addressfinder.io/assets/v3/widget.js";
    script.async = true;
    script.onload = initAddressFinder;
    document.body.appendChild(script);
  }

  function visitorCheck() {
    const validAddress = localStorage.getItem("widgetAddress");
    if (validAddress !== null) {
      try {
        const addressResponse = JSON.parse(validAddress);
        setAttributeValuesMiniCart(addressResponse);
        if (typeof listSuburbsBasedOnPostCode === "function") {
          listSuburbsBasedOnPostCode(
            addressResponse.postcode,
            addressResponse.locality_name
          );
        }
      } catch (e) {
        console.warn("Failed to parse widgetAddress:", e);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    downloadAddressFinder();
    visitorCheck();

    // STEP 1: reevaluate phone-only start button on load
    const p1 = qs("#phone1");
    if (p1 && typeof reevaluateStart === "function") {
      reevaluateStart();
    }

    // STEP 3: initialise "Continue" button based on existing address
    const summaryBtn = qs("#toSummary");
    const addr12 = qs("#address_12");
    if (summaryBtn && addr12) {
      //summaryBtn.disabled = !vAddr(addr12.value);
    }
  });
})();

/* ---------- Persist state ---------- */
function persist() {
  const sdata = JSON.parse(localStorage.getItem("window_state") || "{}");
  let orderType = state.freq;
  state.freq = orderType || state.freq;
  

  if (orderType) {
    localStorage.setItem("cartAttributes", JSON.stringify({
      orderType: { type: orderType }
    }));
  }

  if (vAddr(state.address)) {
    localStorage.setItem("widgetAddress", JSON.stringify({
      address_line_combined: state.address,
      locality_name: state.suburb || "",
      state_territory: state.state || "",
      postcode: state.postcode || ""
    }));
  }

  const widgetAddressAll = localStorage.getItem("widgetAddress");
  const widgetAddress = widgetAddressAll ? JSON.parse(widgetAddressAll) : null;
  const deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

  const preData = qs("#pre_selected_data");

  const hasAddress = state.address && state.suburb;
  const hasDelivery = Object.keys(deliveryInfoNew).length && orderType;

  if (preWrap && preData && !subscriptionContractId) {
    if (hasAddress || hasDelivery) {      
      //console.log('sss1');
      preWrap.style.display = "block";
      preData.innerHTML = `
        <ul style="list-style:none; padding:0; margin:0;">
          ${hasAddress ? `
            <li>
              <strong>Address:</strong>
              <span>${state.address}, ${state.suburb || ""}, ${state.state || ""}, ${state.postcode || ""}</span>
            </li>` : ""
          }
          ${hasDelivery ? `
            <li>
              <strong>Delivery:</strong>
              <span>
                ${orderType ? orderType + "," : ""}
                ${deliveryInfoNew.deliveryDate || ""}
                ${deliveryInfoNew.deliveryStart && deliveryInfoNew.deliveryEnd
                  ? ` [${deliveryInfoNew.deliveryStart} - ${deliveryInfoNew.deliveryEnd}]`
                  : ""
                }
              </span>
            </li>` : ""
          }
        </ul>`;
    } else {      
      //console.log('sss2');
      preWrap.style.display = "none";
    }
  }

  if (isLogin && preWrap && preData && !subscriptionContractId) {    
    if (hasAddress || hasDelivery) {  
      preWrap.style.display = "block";
      preData.innerHTML = `
        <ul style="list-style:none; padding:0; margin:0;">
          ${hasAddress ? `
            <li>
              <strong>Address:</strong>
              <span>${state.address}, ${state.suburb || ""}, ${state.state || ""}, ${state.postcode || ""}</span>
            </li>` : ""
          }
          ${(Object.keys(deliveryInfoNew).length && orderType) ? `
            <li>
              <strong>Delivery:</strong>
              <span>
                ${orderType ? orderType + "," : ""}
                ${deliveryInfoNew.deliveryDate || ""}
                ${deliveryInfoNew.deliveryStart && deliveryInfoNew.deliveryEnd
                  ? ` [${deliveryInfoNew.deliveryStart} - ${deliveryInfoNew.deliveryEnd}]`
                  : ""
                }
              </span>
            </li>` : ""
          }
        </ul>`;

      const pillContact2 = qs("#pillContact2");
      if (pillContact2) {
        pillContact2.textContent = `${state.phone || ""}`;
      }
    }
  }else{
    preWrap.style.display = "none";
  }

  const addrText11 = qs("#address_text_11");
  const addrText12 = qs("#address_text_12");
  //const addrText13 = qs("#address_text_13");
  const pillAddress2 = qs("#pillAddress2");

  const fullAddr = `${state.address || ""}, ${state.suburb || ""}, ${state.state || ""}, ${state.postcode || ""}`;

  if (hasAddress) {
    //addrText11?.classList.remove("hidden");
    addrText12?.classList.remove("hidden");
    //addrText13?.classList.remove("hidden");
    if (addrText11) addrText11.textContent = fullAddr;
    if (addrText12) addrText12.textContent = fullAddr;
    //if (addrText13) addrText13.textContent = fullAddr;
    if (pillAddress2) pillAddress2.textContent = fullAddr;
  } else {
    //addrText11?.classList.add("hidden");
    addrText12?.classList.add("hidden");
    //addrText13?.classList.add("hidden");
  }

  localStorage.setItem("checkoutState", JSON.stringify(state));
}

/* ---------- Restore from localStorage (optional if needed) ---------- */
function restore() {
  try {
    const saved = JSON.parse(localStorage.getItem("checkoutState") || "{}");
    Object.assign(state, saved || {});
  } catch (e) {
    console.warn("Failed to restore checkoutState:", e);
  }

  const pairs = [
    ["#phone1", "phone"],
    ["#address_11", "address"],
    ["#address_12", "address"]
  ];
  pairs.forEach(([sel, key]) => {
    const el = qs(sel);
    if (el && state[key]) el.value = state[key];
  });
}

/* ---------- Progress UI ---------- */
function show(target) {
  const el = typeof target === "string" ? qs(target) : target;
  if (!el) return;
  qsa(".section").forEach(s => s.classList.add("hidden"));
  el.classList.remove("hidden");
  updateProgress();
}

function updateProgress() {
  qsa(".p-step").forEach(n => {
    const idx = Number(n.dataset.step);
    n.classList.remove("active", "done");
    const dot = n.querySelector(".dot");
    if (!dot) return;
    if (idx < state.step) {
      n.classList.add("done");
      dot.textContent = "✓";
    } else if (idx === state.step) {
      n.classList.add("active");
      dot.textContent = String(idx);
    } else {
      dot.textContent = String(idx);
    }
  });

  const progress = qs(".progress");
  if (!progress) return;
  progress.classList.remove("active2", "active3");
  if (state.step >= 2) progress.classList.add("active2");
  if (state.step >= 3) progress.classList.add("active3");
}

function reevaluateStart() {
  const phoneVal = (phone1?.value || "").trim();

  const info = validateAndNormalizeAuPhone(phoneVal);

  if (!startHint) return;

  if (info.ok) {
    startHint.textContent = "Enter a valid Australian mobile number and Address to continue.";
  } else {
    startHint.textContent = "Enter a valid Australian mobile number to continue.";
  }

}

/* ---------- Event wiring step 1 ---------- */
if (phone1) {
  phone1.addEventListener("input", () => {
    state.phone = phone1.value.trim();
    reevaluateStart();
    persist();
  });
}

/* ---------- Start button click: go to Step 2 (Plan) ---------- */
if (startBtn) {
  startBtn.addEventListener("click", () => {
    document.querySelector(".timerContainer")?.classList.remove("not_added");

    if(state.phone && state.address && (state.phone != '') && (state.address != '')){  


      const p1 = (phone1?.value || "").trim();
      const info = validateAndNormalizeAuPhone(p1);
      setFieldState(phone1, info.ok, "Enter a valid AU phone");

      state.phone = p1;

      if (!info.ok) return;
      qs('#back_1_1')?.classList.add('hidden');
      persist();
      state.step = 2;
      show("#step2");    
      localStorage.setItem("window_state", JSON.stringify(state));        

    }else{

      if ((state.phone == '') || (state.address == '')) {
        qs('#back_1_1')?.classList.remove('hidden');
        if(state.phone != ''){
          address_group?.classList.remove("hidden"); 
          phone_group?.classList.add("hidden");
        }else{
          phone_group?.classList.remove("hidden"); 
          address_group?.classList.add("hidden");
        } 
        startBtn.disabled = true;
        step1_divider?.classList.add("hidden");
      }  

    }

  });
}

/* ---------- Plan selection helpers ---------- */
function applyFreqSelection(freq) {
  const row = qs("#freqRow");
  if (!row) return;

  qsa(".freq-btn").forEach(b => {
    b.classList.toggle("selected", b.dataset.freq === freq);
  });

  state.freq = freq || "";

  const nextBtn = qs("#toSummary");
  if (nextBtn) {
    if (state.plan === "subscribe") {
      
      nextBtn.disabled = !state.freq;
      let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo")   || "{}");
      updateFutureDeliveries(loca_delV.deliveryDate,state.freq);
      qs(".windowDeliery").classList.remove("d-none");      
      qs(".cycle_wrap").classList.remove("d-none");

    } else {
      nextBtn.disabled = !state.plan;
      state.freq === "OneTimePurchase"
      qs(".windowDeliery").classList.add("d-none");      
      qs(".cycle_wrap").classList.add("d-none");
    }
  }
}

function applyPlanSelection(plan) {
  qsa(".card_plan").forEach(card => {
    card.classList.toggle("selected", card.dataset.plan === plan);
  });

  const nextBtn = qs("#toSummary");
  const card = qs('.card_plan[data-plan="'+state.plan+'"]');
  if (nextBtn) {
    if (plan === "subscribe") {

      nextBtn.disabled = !state.freq;      
      let btnWrap = card?.querySelector(".freq");
      let btn = card?.querySelector('.freq-btn[data-freq="'+state.freq+'"]');

      if (btn) {
        // clear all first
        qsa(".freq-btn").forEach(b => b.classList.remove("selected"));
        btn.classList.add("selected");
        btnWrap.classList.remove("hidden");
      }

      
      if(state.freq !== "OneTimePurchase"){
        let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo")   || "{}");
        updateFutureDeliveries(loca_delV.deliveryDate, state.freq);
        qs(".windowDeliery").classList.remove("d-none");    
        qs(".cycle_wrap").classList.remove("d-none");
      }else{
        qs(".windowDeliery").classList.add("d-none");    
        qs(".cycle_wrap").classList.add("d-none");
      }
      
    } else {

      //state.freq = "OneTimePurchase";
      nextBtn.disabled = !state.plan;
      qs(".windowDeliery").classList.add("d-none");  
      qs(".cycle_wrap").classList.add("d-none");

    }
  }
}

/* ---------- Step 2 (Plan) event wiring ---------- */
const planCards = qsa(".card_plan");
planCards.forEach(c => {
  c.addEventListener("click", () => {
    planCards.forEach(x => x.classList.remove("selected"));
    c.classList.add("selected");
    state.plan = c.dataset.plan;    

    if (state.plan === "subscribe") {
      
      state.freq = "WeeklySubscription";
      const freqRow = qs("#freqRow");
      if (freqRow) freqRow.classList.remove("hidden");

      let autoFreq = "";
      const freqAttrBtn =
        qs(".freq-btn.selected") ||
        qs('.freq-btn[data-selected="true"]') ||
        qs('.freq-btn[aria-selected="true"]');

      if (freqAttrBtn) {
        autoFreq = freqAttrBtn.dataset.freq;
      } else if (state.freq) {
        autoFreq = state.freq;
      } else {
        autoFreq = "WeeklySubscription";
      }
      if (autoFreq) {
        applyFreqSelection(autoFreq);
      }
      if(state.freq !== "OneTimePurchase"){
        let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo")   || "{}");
        updateFutureDeliveries(loca_delV.deliveryDate,autoFreq);
        qs(".windowDeliery").classList.remove("d-none");
        qs(".cycle_wrap").classList.remove("d-none");
      }else{
        qs(".windowDeliery").classList.add("d-none");
        qs(".cycle_wrap").classList.add("d-none");
      }

    } else {

      state.freq = "OneTimePurchase";
      const freqRow = qs("#freqRow");
      if (freqRow) freqRow.classList.add("hidden");
      const nextBtn = qs("#toSummary");
      if (nextBtn) nextBtn.disabled = false;
      qs(".windowDeliery").classList.add("d-none");
      qs(".cycle_wrap").classList.add("d-none");

    }

    //console.log(state);

    applyPlanSelection(c.dataset.plan);
    persist();

    localStorage.setItem("window_state", JSON.stringify(state));

  });
});

qsa(".freq-btn").forEach(b => {
  b.addEventListener("click", (e) => {
    qsa(".freq-btn").forEach(x => x.classList.remove("selected"));
    e.currentTarget.classList.add("selected");
    state.freq = e.currentTarget.dataset.freq;    
    if(state.freq !== 'OneTimePurchase'){
      let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo")   || "{}");
      updateFutureDeliveries(loca_delV.deliveryDate,state.freq);
      qs(".windowDeliery").classList.remove("d-none");
      qs(".cycle_wrap").classList.remove("d-none");
    }else{
      qs(".windowDeliery").classList.add("d-none");
      qs(".cycle_wrap").classList.add("d-none");
    }
    const nextBtn = qs("#toSummary");
    if (nextBtn) nextBtn.disabled = false;
    applyFreqSelection(state.freq);
    localStorage.setItem("window_state", JSON.stringify(state));
    persist();
  });
});

/* ---------- Step 2 -> Step 3 ---------- */
if (qs("#toPlan")) {
  qs("#toPlan").addEventListener("click", () => {
    state.step = 3;
    show("#step3");
    persist();

    if (state.freq === "OneTimePurchase") {
      qs(".windowDeliery").classList.add("d-none");
      qs(".cycle_wrap").classList.add("d-none");
    }else{
      let loca_delV = JSON.parse(localStorage.getItem("deliveryInfo")   || "{}");
      updateFutureDeliveries(loca_delV.deliveryDate,state.freq);
      qs(".windowDeliery").classList.remove("d-none");
      qs(".cycle_wrap").classList.remove("d-none");
    }

  });
}

/* ---------- Back buttons ---------- */
qsa("a.back").forEach(a => {
  a.addEventListener("click", () => {

    const target = a.dataset.back; 
    let phone_group = qs("#phone_group");
    let address_group = qs("#address_group");
    //console.log(target);

    if (target === "1") {
      state.step = 1;
      show("#step1");   
      if(isLogin){  
        phone_group?.classList.add('hidden');
      }else{        
        phone_group?.classList.remove('hidden');
        step1_divider?.classList.remove("hidden");    
        step1_divider.innerHTML = '<i class="fa fa-plus"></i>';  
      }
      address_group?.classList.remove('hidden'); 

    } else if (target == "1.1") {

      state.step = 1;
      show("#step1");
      phone1Text.innerHTML = "Enter your mobile number. We’ll check if you already have an account.";

      if(!isLogin){ 
        if ((state.phone == '') || (state.address == '')) {
          qs('#back_1_1')?.classList.add('hidden');
          if(state.phone == ''){
            address_group?.classList.remove("hidden"); 
            phone_group?.classList.add("hidden");
          }else{
            phone_group?.classList.remove("hidden"); 
            address_group?.classList.add("hidden");
          }  
          step1_divider?.classList.add("hidden");
          startBtn.disabled = false;
        }         
        step1_divider.innerHTML = '<i class="fa fa-plus"></i>';  
      }

    } else if (target === "2") {
      state.step = 2;
      show("#step2");
    } else if (target === "3") {
      state.step = 3;
      show("#step3");
    } else {
      state.step = 1;
      show("#step1");
      if(isLogin){  
        phone_group?.classList.add('hidden');
      }else{        
        phone_group?.classList.remove('hidden'); 
        step1_divider?.classList.remove("hidden");   
        step1_divider.innerHTML = '<i class="fa fa-plus"></i>';       
      }
      address_group?.classList.remove('hidden'); 
    }
    persist();
  });
});

/* ---------- Step 4: Summary button ---------- */
if (qs("#toSummary")) {
  qs("#toSummary").addEventListener("click", () => {
    localStorage.setItem("window_state", JSON.stringify(state));
    if(state.phone!=''){

      const summary = qs("#orderSummary");
      if (summary) {
        summary.innerHTML = `
          <div class="item"><span>Phone</span><strong>${state.phone}</strong></div>
          <div class="item"><span>Address</span><strong>${state.address}</strong></div>
          <div class="item"><span>Delivery</span><strong>${state.date || ""}</strong></div>
          <div class="item"><span>Time</span><strong>${state.time || ""}</strong></div>
          <div class="item"><span>Plan</span><strong>${
            state.plan === "subscribe"
              ? `Subscribe & Save (${state.freq || "-"})`
              : "One-Time Order"
          }</strong></div>
        `;
      }
      // progress has only 3 steps; summary is still "step 3 done"
      state.step = 3;
      persist();

      if (window.state.freq) {
        const sel = document.getElementById("order-frequency");
        if (sel) {
          sel.value = window.state.freq;
          sel.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      qs("#complete").click();
      
    }else{

      show('#step1');

    }
  });
}

/* ---------- Step 5: Complete ---------- */
qs("#complete")?.addEventListener("click",()=>{
  if(!(state.phone && state.address)){
    alert("Please complete Email, Phone, and Address before placing order.");
    return;
  }
  if (typeof window.checkoutValidate === "function") {
    window.checkoutValidate("mini-cart");
  } else {
    persist();
    alert("Order details saved. Proceeding to checkout...");
  }
});

function maskEmail(email) {
  if (!email || !email.includes("@")) return "";
  const [name, domain] = email.split("@");
  let length = name.length;
  return name.charAt(0) + "***"+name.charAt(length - 1)+"@" + domain;
}


/* ---------- Pre-selected chip click ---------- */
document.addEventListener("DOMContentLoaded", () => {
  const preSelected = document.querySelector("#pre_selected_data");
  if (!preSelected) return;

  preSelected.addEventListener("click", () => {
    ["border-topbg-white", "cart-item-wrap", "cart-item-title"].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });

    const flow = document.getElementById("finalflow");
    if (flow) flow.style.display = "block";    
    let phone_group = qs("#phone_group");
    let address_group = qs("#address_group");

    if (typeof show === "function") {   

      window.state.step = 2;
      show("#step2");

    } else {

      document.querySelectorAll("#finalflow .section").forEach(s => s.classList.add("hidden"));
      window.state.step = 1;
      document.querySelector("#step1")?.classList.remove("hidden");      
      phone_group?.classList.remove('hidden');
      address_group?.classList.add('hidden');
      
    }

    if (document.getElementById("phone1")?.value === "") {
      document.getElementById("phone1")?.focus();
    } else {
      document.getElementById("address_12")?.focus();
    }

    flow?.scrollIntoView({ behavior: "smooth", block: "start" });
    console.log("✅ Jumped to mini-cart flow");
  });
  
  const loginForm = document.querySelector("#customer_login_new");
  if (!loginForm) return;

  let msgEl = document.querySelector("#loginMessage");
  if (!msgEl) {
    msgEl = document.createElement("div");
    msgEl.id = "loginMessage";
    msgEl.style.marginTop = "10px";
    msgEl.style.fontSize = "14px";
    loginForm.parentNode.insertBefore(msgEl, loginForm.nextSibling);
  }

  function showMessage(msg, type = "info") {
    msgEl.textContent = msg;
    msgEl.classList.remove("hidden");
    msgEl.style.color = type === "success"
      ? "#16a34a"
      : type === "error"
      ? "#dc2626"
      : "#334155";
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    btn.dataset.origText = btn.dataset.origText || btn.textContent;
    btn.textContent = busy ? "Signing in…" : btn.dataset.origText;
  }

  /*
   * ---------- Register form (AJAX create_customer) ----------
   * Requires: {% form 'create_customer', id: 'RegisterFormNew' %}
   */
  const registerForm = document.querySelector("#RegisterFormNew");
  if (registerForm) {
    let regMsgEl = document.querySelector("#registerMessage");
    if (!regMsgEl) {
      regMsgEl = document.createElement("div");
      regMsgEl.id = "registerMessage";
      regMsgEl.style.marginTop = "10px";
      regMsgEl.style.fontSize = "14px";
      registerForm.parentNode.insertBefore(regMsgEl, registerForm.nextSibling);
    }

    function showRegisterMessage(msg, type = "info") {
      regMsgEl.textContent = msg;
      regMsgEl.classList.remove("hidden");
      regMsgEl.style.color =
        type === "success" ? "#16a34a" :
        type === "error"   ? "#dc2626" :
                            "#334155";
    }

    function setRegisterBusy(btn, busy) {
      if (!btn) return;
      btn.disabled = busy;
      btn.dataset.origText = btn.dataset.origText || btn.textContent;
      btn.textContent = busy ? "Creating account…" : btn.dataset.origText;
    }

    async function ajaxRegister(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      setRegisterBusy(submitBtn, true);
      showRegisterMessage("");

      try {
        const formData = new FormData(form);

        // Shopify create_customer posts to /account or form.action
        const response = await fetch("/account/register", {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        const raw = await response.text();
        const doc = new DOMParser().parseFromString(raw, "text/html");

        // Look for standard Shopify error nodes
        const errorNode = doc.querySelector(
          ".note.errors, .form-message--error, .alert-error, .errors"
        );

        if (errorNode) {
          const msg = errorNode.textContent.trim() || "There was a problem creating your account.";
          showRegisterMessage(msg, "error");
          return { ok: false, error: msg };
        } else {
          // 🎯 Success – Shopify usually redirects to /account or to return_to
          showRegisterMessage("✅ Account created successfully! Please check your email and then log in.", "success");
          return { ok: true };
        }

      } catch (err) {
        console.error("❌ Register exception:", err);
        showRegisterMessage("Network error. Please try again.", "error");
        return { ok: false, error: err.message };
      } finally {
        const submitBtn = form.querySelector('[type="submit"]');
        setRegisterBusy(submitBtn, false);
      }
    }

    // 🔸 UPDATED: handle register submit with /api/customers/find
    async function handleRegisterSubmit(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      const emailInput = form.querySelector("#RegisterEmail");
      const emailVal = (emailInput?.value || "").trim();

      if (!emailVal) {
        showRegisterMessage("Please enter your email address.", "error");
        return;
      }
      if (!isValidEmailNew(emailVal)) {
        showRegisterMessage("Enter a valid email address.", "error");
        return;
      }

      login1Text?.classList.add('hidden');

      // Busy + loader
      setRegisterBusy(submitBtn, true);
      showRegisterMessage("Checking your email…");
      showMiniCartLoader();

      try {
        // 1) Call your email find endpoint
        const findRes = await fetch(
          "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/customers/find",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: emailVal })
          }
        );

        const data = await findRes.json();
        //console.log("📧 /api/customers/find result:", data);

        const isFound = !!data?.isFound;
        const nodes = isFound ? ( data?.customer ? [data.customer] : [] ) : [];

        if (isFound && nodes) {

          login1Text?.classList.remove('hidden');
          msgEl?.classList.add('hidden');
          // Same state logic as phone check
          const enabledNode  = nodes.find(n => n.state === "ENABLED");
          const invitedNode  = nodes.find(n => n.state === "INVITED");
          const disabledNode = nodes.find(n => n.state === "DISABLED");

          //console.log("enabledNode (email)", enabledNode);
          //console.log("invitedNode (email)", invitedNode);
          //console.log("disabledNode (email)", disabledNode);

          const loginBox    = document.querySelector("#loginPart");
          const registerBox = document.querySelector("#RegisterPart");
          const loginEmail  = document.querySelector("#CustomerEmailNEW");

          // 🟢 ENABLED → show login form & prefill email
          if (enabledNode) {
            if (modal) modal.style.display = "block";
            registerBox?.classList.add("hidden");
            loginBox?.classList.remove("hidden");

            if (loginEmail) loginEmail.value = emailVal;     

          }

          // 🟡 INVITED or 🔴 DISABLED → re-send invite via /api/invite
          if (invitedNode || disabledNode) {
            const node = invitedNode || disabledNode;
            const gid = node.id || "";
            const numericId = gid.split("/").pop(); // "gid://shopify/Customer/7702548218172" -> "7702548218172"

            if (numericId) {
              try {
                const inviteRes = await fetch(
                  "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: numericId })
                  }
                );
                const inviteJson = await inviteRes.json();
                console.log("📨 /api/invite (email) response:", inviteJson);
              } catch (inviteErr) {
                console.error("❌ /api/invite (email) error:", inviteErr);
              }
            }

            if (modal) modal.style.display = "block";
            registerBox?.classList.add("hidden");
            loginBox?.classList.remove("hidden");
            if (loginEmail) loginEmail.value = emailVal;
          }

          if(disabledNode){
            login1Text.innerHTML = "Your account is disabled. We’ve sent invitation — please accept it to proceed.";
          }else if(invitedNode){
            login1Text.innerHTML = "You haven’t accepted our invitation yet. We’ve sent it again — please accept it to proceed.";
          }else{
            login1Text.innerHTML = "We found an account with this email. Please sign in instead.";
          }
          
          login1Text?.classList.add('error');

          return;

        } else {
          // NOT FOUND → proceed with standard register flow
          await ajaxRegister(form);
          return;
        }

      } catch (err) {
        console.error("❌ /api/customers/find (email) error, falling back:", err);
        // On error – still try to create account as before
        await ajaxRegister(form);
      } finally {
        hideMiniCartLoader();
        setRegisterBusy(submitBtn, false);
        /*setTimeout(() => {
          const urlNew = new URL(window.location.href);
          urlNew.searchParams.set("open-mini-cart", "true");
          location.href = urlNew;
        }, 1200);
        return { ok: true };*/
      }
    }

    // 🔹 Hook up the new handler
    registerForm.addEventListener("submit", function (e) {
      e.preventDefault();
      handleRegisterSubmit(registerForm);
    });
  }


  async function ajaxLogin(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    setBusy(submitBtn, true);
    showMessage("");
    try {
      const formData = new FormData(form);
      const response = await fetch("/account/login", {
        method: "POST",
        body: formData,
        credentials: "same-origin",
        headers: {
          "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const raw = await response.text();
      const doc = new DOMParser().parseFromString(raw, "text/html");
      const errorNode = doc.querySelector(
        ".note.errors, .form-message--error, .alert-error, #customer_login .errors"
      );

      if (errorNode) {
        const msg = errorNode.textContent.trim() || "Incorrect email or password.";
        showMessage(msg, "error");
        return { ok: false, error: msg };
      } else {
        showMessage("✅ Login successful! Redirecting...", "success");
        setTimeout(() => {
          const urlNew = new URL(window.location.href);
          urlNew.searchParams.set("open-mini-cart", "true");
          location.href = urlNew;
        }, 1200);
        return { ok: true };
      }

    } catch (err) {
      console.error("❌ Exception:", err);
      showMessage("Network error. Please try again.", "error");
      return { ok: false, error: err.message };
    } finally {
      setBusy(form.querySelector('[type="submit"]'), false);
    }
  }

  loginForm.addEventListener("submit", function (e) {
    e.preventDefault();
    ajaxLogin(loginForm);
  });

  /* ---------- Recover Password (AJAX) ---------- */
  const recoverFormWrap = document.querySelector("#RecoverPasswordFormNEW");
  const recoverForm = recoverFormWrap ? recoverFormWrap.querySelector("form") : null;

  if (recoverForm) {
    let recMsgEl = document.querySelector("#recoverMessage");
    if (!recMsgEl) {
      recMsgEl = document.createElement("div");
      recMsgEl.id = "recoverMessage";
      recMsgEl.style.marginTop = "10px";
      recMsgEl.style.fontSize = "14px";
      recoverForm.parentNode.insertBefore(recMsgEl, recoverForm.nextSibling);
    }

    function showRecoverMessage(msg, type = "info") {
      recMsgEl.textContent = msg;
      recMsgEl.classList.remove("hidden");
      recMsgEl.style.color =
        type === "success" ? "#16a34a" :
        type === "error"   ? "#dc2626" :
                            "#334155";
    }

    function setRecoverBusy(btn, busy) {
      if (!btn) return;
      btn.disabled = busy;
      btn.dataset.origText = btn.dataset.origText || btn.textContent;
      btn.textContent = busy ? "Sending reset link…" : btn.dataset.origText;
    }

    async function ajaxRecover(form) {
      const submitBtn = form.querySelector('[type="submit"]');
      setRecoverBusy(submitBtn, true);
      showRecoverMessage("");

      try {
        const formData = new FormData(form);
        const action = form.getAttribute("action") || "/account/recover";

        const response = await fetch(action, {
          method: "POST",
          body: formData,
          credentials: "same-origin",
          headers: {
            "Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        const raw = await response.text();
        const doc = new DOMParser().parseFromString(raw, "text/html");

        const errorNode = doc.querySelector(
          ".note.errors, .form-message--error, .alert-error"
        );
        const successNode = doc.querySelector(
          ".note.form-success, .form-message--success, .alert-success"
        );

        if (errorNode) {
          const msg = errorNode.textContent.trim() || "We couldn't find an account with that email.";
          showRecoverMessage(msg, "error");
        } else if (successNode) {
          const msg = successNode.textContent.trim() ||
            "If an account exists with that email, we’ve sent a password reset link.";
          showRecoverMessage(msg, "success");
        } else {
          showRecoverMessage(
            "If an account exists with that email, we’ve sent a password reset link.",
            "success"
          );
        }

      } catch (err) {
        console.error("❌ Recover password exception:", err);
        showRecoverMessage("Network error. Please try again.", "error");
      } finally {
        setRecoverBusy(form.querySelector('[type="submit"]'), false);
      }
    }

    recoverForm.addEventListener("submit", function (e) {
      e.preventDefault();
      ajaxRecover(recoverForm);
    });
  }

});

/* ---------- Email/Phone validation + Phone API + Invite ---------- */
const on = (el, ev, fn) => el && el.addEventListener(ev, fn, { passive: true });

const lastChecked = new Map(); // key=e164phone
const DEDUPE_TTL_MS = 2 * 60 * 1000;

async function checkUser(e164phone, click = false) {
  if (!e164phone) return;

  const key = e164phone;
  const now = Date.now();
  /*const last = lastChecked.get(key) || 0;
  if (now - last < DEDUPE_TTL_MS) return;
  lastChecked.set(key, now);*/

  const continueBtnDelivery = qs("#toSummary");  

  let phone_group   = qs("#phone_group");  
  let address_group = qs("#address_group"); 

  //step1_divider?.classList.add("hidden");
  step1_divider.innerHTML = '<i class="fa fa-plus"></i>';

  showMiniCartLoader();

  if (continueBtn) continueBtn.disabled = true;
  document.querySelector("#loginPart")?.classList.add("hidden");
  continueBtn?.classList.remove('hidden');

  try {
    startHint?.classList.add("hidden");
    address_group?.classList.add("hidden");
    phone1SendAgain?.classList.add("hidden");

    const res = await fetch("https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/user", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone: e164phone }),
      redirect: "follow"
    });

    const result = await res.json();
    // console.log("Phone lookup result:", result);

    const found = result && result.isFound === true;
    const nodes = Array.isArray(result?.nodes) ? result.nodes : [];

    //console.log(nodes);

    if (found && nodes.length) {
      // ---- NEW: state-based logic ----
      const enabledNode  = nodes.find(n => n.state === "ENABLED");
      const invitedNode  = nodes.find(n => n.state === "INVITED");
      const disabledNode = nodes.find(n => n.state === "DISABLED");

      //console.log('enabledNode', enabledNode);
      //console.log('invitedNode', invitedNode);
      //console.log('disabledNode', disabledNode);

      let gid = "";
      let numericId = "";

      let email = enabledNode?.email || invitedNode?.email || disabledNode?.email || ""; 
      let maskedEmail = maskEmail(email);

      if(maskedEmail == ''){
        maskedEmail = '***@gmail.com';
      }
      //login1Text?.classList.remove('hidden');

      if ((invitedNode || disabledNode) && !enabledNode) {

        continueBtn?.classList.remove('hidden');

        if(disabledNode){ 
          gid = disabledNode.id || "";
          numericId = gid.split("/").pop();
        }else{
          gid = invitedNode.id || "";
          numericId = gid.split("/").pop();
        }

        if (numericId) {
          try {
            const inviteRes = await fetch("https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: numericId })
            });
            const inviteJson = await inviteRes.json();
            console.log("📨 /api/invite response:", inviteJson);
          } catch (inviteErr) {
            console.error("❌ /api/invite error:", inviteErr);
          }
        }

        startHint?.classList.add("hidden");
        startBtnShowActive(false);
        
        address_group?.classList.add("hidden");
        step1_divider?.classList.add("hidden");
        phone1SendAgain?.classList.remove("hidden");

        if(disabledNode){
          //phone1Text.innerHTML = "Your account is disabled. We’ve sent invitation — please accept it to proceed.";
          phone1Text.innerHTML = `Your account (<strong>${e164phone}</strong> and <strong>${maskedEmail}</strong>) is disabled.  We’ve sent you an invitation — please accept it to proceed. `;
          //login1Text.innerHTML = `Your account (<strong>${maskedEmail}</strong>) is disabled.  We’ve sent you an invitation — please accept it to proceed. `;
        }else{
          //phone1Text.innerHTML = "You haven’t accepted our invitation yet. We’ve sent it again — please accept it to proceed.";
          phone1Text.innerHTML = `You haven’t accepted the invitation sent to <strong>${e164phone}</strong> and <strong>${maskedEmail}</strong>. We’ve sent it again — please accept it to proceed.`;
          //login1Text.innerHTML = `You haven’t accepted the invitation sent to <strong>${maskedEmail}</strong>. We’ve sent it again — please accept it to proceed.`;
        }
        phone1Text?.classList.add('error');
        //login1Text?.classList.add('error');

      }else{

        // ENABLED (or neither invited/disabled) → behave like original "found" flow
        if (modal) modal.style.display = "block";
        document.querySelector("#loginPart")?.classList.remove("hidden");

        startBtnShowActive(false);

        continueBtn?.classList.add('hidden');        
        // show address field but keep phone in place for existing user
        address_group?.classList.add("hidden");
        step1_divider?.classList.add("hidden");

        //phone1Text.innerHTML = "We found have found an account linked with your mobile number! Please login to continue:";
        phone1Text.innerHTML = `We found an account linked to <strong>${e164phone}</strong> and <strong>${maskedEmail}</strong>. Please log in to continue.`;
        //login1Text.innerHTML = `We found an account linked to <strong>${maskedEmail}</strong>. Please log in to continue.`;
        phone1Text?.classList.remove('error');
        //login1Text?.classList.remove('error');

        if (((state.phone != '') && state.phone) && ((state.address != '') && state.address)) {
          // both already present → auto-continue
          continueBtn?.click();
        } else {
          // show address field but keep phone in place for existing user
          address_group?.classList.add("hidden");
          step1_divider?.classList.add("hidden");
        }
      }

    } else {

      // ----- NOT FOUND → original "new user" flow -----
      if (modal) modal.style.display = "block";
      document.querySelector("#loginPart")?.classList.add("hidden");
      startHint?.classList.remove("hidden");
      continueBtn?.classList.remove('hidden');
      
      startBtnShowActive(true);

      if (((state.phone != '') && state.phone) && ((state.address != '') && state.address)) {
        continueBtn?.click();
      } else {
        address_group?.classList.remove("hidden");        
        phone_group?.classList.add("hidden");   
        step1_divider?.classList.add("hidden");
        qs('#back_1_1')?.classList.remove('hidden');
      }

    }

    persist(); 
    
  } catch (err) {
    console.error("API error:", err);
  } finally {
    hideMiniCartLoader();
  }
}

async function sendInvitationByPhone(e164phone) {
  if (!e164phone) {
    return { ok: false, error: "missing-phone" };
  }

  try {
    // 1) Look up customer(s) by phone
    const userRes = await fetch(
      "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/user",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: e164phone })
      }
    );

    const userJson = await userRes.json();
    const nodes = Array.isArray(userJson.nodes) ? userJson.nodes : [];

    if (!userJson.isFound || nodes.length === 0) {
      return { ok: false, found: false, error: "not-found" };
    }

    // 2) Find INVITED customer node
    const invitedNode = nodes.find(n => n.state === "INVITED");

    if (!invitedNode) {
      return { ok: false, found: true, invited: false, error: "no-invited-node" };
    }

    // 3) Extract numeric Shopify customer ID
    const gid = invitedNode.id || "";
    const numericId = gid.split("/").pop();

    if (!numericId) {
      return { ok: false, found: true, invited: false, error: "invalid-id" };
    }

    // 4) Send invitation
    const inviteRes = await fetch(
      "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com/api/invite",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: numericId })
      }
    );

    const inviteJson = await inviteRes.json();
    //console.log("📨 Invite Response:", inviteJson);

    if (inviteJson?.response?.success) {      
      phone1Text.innerHTML = "We’ve sent it again — please accept it to proceed.";
      phone1Text?.classList.add('error');
    }else{
      phone1Text?.classList.remove('error');
      phone1Text?.classList.add('hidden');
    }

  } catch (err) {
    console.error("❌ sendInvitationByPhone error:", err);
    return { ok: false, error: err.message };
  }
}

function attachPairValidation(emailSel, phoneSel) {
  const phoneEl = qs(phoneSel);
  if (!phoneEl) return;

  const tryCheck = () => {
    const phoneRaw = phoneEl?.value || "";

    if(phoneRaw == '' ){
      if (continueBtn) continueBtn.disabled = true;
    }

    const phoneInfo = validateAndNormalizeAuPhone(phoneRaw);
    setFieldState(phoneEl, phoneInfo.ok, "Enter a valid AU phone");

    if (phoneInfo.ok && !isLogin) {
      continueBtn.disabled = false;
      checkUser(phoneInfo.e164);
    }
    if (phoneEl.id === "phone1") {
      // keep start button state in sync
      reevaluateStart();
    }
  };

  let d2;
  on(phoneEl, "input", () => {
    clearTimeout(d2);
    d2 = setTimeout(tryCheck, 500);
  });
  on(phoneEl, "blur", tryCheck);
}

attachPairValidation("#email1", "#phone1");

/* ---------- Basic invalid styles injection ---------- */
(function injectValidationStyles() {
  const style = document.createElement("style");
  style.textContent = `
    .is-invalid{ border-color:#ef4444 !important; }
    .error-text{ display:block; margin-top:4px; font-size:12px; }
  `;
  document.head.appendChild(style);
})();

/* ---------- Next Deliveries preselect ---------- */
function initNextDeliveriesPreselect() {
  const box = qs(".nextDeliveries");
  if (!box) return;

  function pick() {
    const preferred =
      box.querySelector("[data-selected='true']") ||
      box.querySelector("button[aria-selected='true']") ||
      box.querySelector("button:not([disabled])");

    if (preferred) {
      box.querySelectorAll("button").forEach(b => b.classList.remove("selected"));
      preferred.classList.add("selected");
      state.nextDelivery =
        preferred.dataset.value ||
        preferred.dataset.date ||
        preferred.textContent.trim();
      persist();
    }
  }

  pick();
  const mo = new MutationObserver(() => pick());
  mo.observe(box, { childList: true, subtree: true });
}

/* ---------- Plan/freq bootstrap preselect ---------- */
function bootstrapPreselects() {
  const root = qs("#finalflow");
  const attrPlan = root?.dataset.plan;
  const attrFreq = root?.dataset.freq;

  const plan = state.plan || attrPlan || (qs('.card_plan[data-plan="subscribe"]') ? "subscribe" : "onetime");
  applyPlanSelection(plan);

  if (plan === "subscribe") {
    const freqAttrBtn =
      qs(".freq-btn[data-selected='true']") ||
      qs(".freq-btn[aria-selected='true']");
    const freq = state.freq || attrFreq || (freqAttrBtn ? freqAttrBtn.dataset.freq : "");
    if (freq) applyFreqSelection(freq);
  }
}

/* ---------- DOMContentLoaded final boot ---------- */
document.addEventListener("DOMContentLoaded", function () {

  let phone_group = qs("#phone_group");  
  let address_group = qs("#address_group"); 

  if(userLoggedIn && Array.isArray(customerData.tags) && (customerData.tags.includes("keto_customers") || customerData.tags.includes("T1") || customerData.tags.includes("T2") || customerData.tags.includes("T3"))){
    subscribeCard?.classList.add("hidden");
    onetimeCard?.classList.remove("hidden");
  } else {
    subscribeCard?.classList.remove("hidden");
    onetimeCard?.classList.remove("hidden");
  }

  bootstrapPreselects();
  initNextDeliveriesPreselect();

  // Ensure start state
  const p1 = qs("#phone1");
  if (p1) {
    if(window_state.phone){
      state.phone = window_state.phone;
      qs("#phone1").value = window_state.phone;
    }else{      
      qs("#phone1").value = state.phone;
    }
    reevaluateStart();
  }  

  // FIX: use existing element, don't crash on undefined variable
  phone1SendAgain?.addEventListener("click",()=>{
    const phoneInfo = validateAndNormalizeAuPhone(qs("#phone1").value);
    if (phoneInfo.ok && !isLogin) {
      sendInvitationByPhone(phoneInfo.e164);
    }
  });

  if (isLogin) {

    phone_group?.classList.add("hidden");

    if((state.phone && state.address && state.suburb && state.state && state.postcode && (state.phone != '') && (state.address != '') && (state.suburb != '') && (state.state != '') && (state.postcode != ''))){
      
      state.step = 2;
      show("#step2");
      preWrap.style.display = "block";

    }else{

      startHint?.classList.remove("hidden");      
      step1_divider?.classList.remove("hidden");

      state.step = 1;
      show("#step1");
      preWrap.style.display = "none";

    }
    
    persist();

  } else {

    if((state.phone && state.address && state.suburb && state.state && state.postcode && (state.phone != '') && (state.address != '') && (state.suburb != '') && (state.state != '') && (state.postcode != ''))){

    }else{

      step1_divider?.classList.remove("hidden");   

    }

    state.step = state.step || 1;
    show("#step1");

  }   

  if(((state.phone != '') && state.phone) || ((state.address != '') && state.address)){

    step1_divider.innerHTML = '<i class="fa fa-plus"></i>';
    step1_divider?.classList.add('hidden');

    if((state.phone != '') && state.phone){

      if (!isLogin) {

        phone_group?.classList.add("hidden");

      }

    }else if((state.address != '') && state.address){

      if (!isLogin) {

        address_group?.classList.add("hidden"); 

      } 
    }
    
  }else{

    step1_divider.innerHTML = 'or';

  }  

  updateProgress();
});